import { a as setAssetPath } from './index-0859a102.js';
import trim from 'lodash/trim';
import { BehaviorSubject } from 'rxjs';

const colors$1 = {
    white: "#fff",
    "gray-100": "#ebebeb",
    "gray-200": "#4e5d6c",
    "gray-300": "#dee2e6",
    "gray-400": "#ced4da",
    "gray-500": "#adb5bd",
    "gray-600": "#868e96",
    "gray-700": "#495057",
    "gray-800": "#343a40",
    "gray-900": "#212529",
    black: "#000",
    blue: "#f06721",
    indigo: "#6610f2",
    purple: "#6f42c1",
    pink: "#e83e8c",
    red: "#d9534f",
    orange: "#f0ad4e",
    yellow: "#f0ad4e",
    green: "#5cb85c",
    teal: "#20c997",
    cyan: "#5bc0de",
    transparent: "rgba(0,0,0,0)",
    "lightgreen": "#90ee90",
    "lightred": "#ff6347"
};
const specialColors$1 = {
    primary: colors$1["blue"],
    secondary: colors$1["gray-200"],
    success: colors$1["green"],
    info: colors$1["cyan"],
    warning: colors$1["yellow"],
    danger: colors$1["red"],
    light: "#a9b5c1",
    dark: colors$1["gray-200"],
    "body-bg": "#2b3e50",
    "body-color": colors$1["gray-100"],
    "bg-header": "rgba(255, 255, 255, .075)",
    "dark-contrast": "#212529",
    "light-primary-bg": "#f9e1d1",
    "light-primary-color": "#74370e",
    "light-secondary-bg": "#dcdfe2",
    "light-secondary-color": "#293038",
    "light-success-bg": "#D2F9D2",
    "light-success-color": "#306030",
    "light-info-bg": "#def2f8",
    "light-info-color": "#2f6473",
    "light-warning-bg": "#fcefdc",
    "light-warning-color": "#7d5a29",
    "light-danger-bg": "#f7dddc",
    "light-danger-color": "#712b29",
    "light-light-bg": "#eef0f3",
    "light-light-color": "#595f65",
    "light-dark-bg": "#abb6c2",
    "light-dark-color": "#2b3e50",
};
const attributes$1 = {
    "input-border-color": colors$1["transparent"],
    "input-group-addon-color": specialColors$1["body-color"],
    "input-group-addon-bg": colors$1["gray-200"],
    "text-muted": "rgba(255, 255, 255, .4)",
    "table-accent-bg": "rgba(255, 255, 255, .05)",
    "table-hover-bg": "rgba(255, 255, 255, .075)",
    "table-border-color": "rgba(0, 0, 0, .15)",
    "table-head-bg": specialColors$1["light"],
    "table-dark-bg": specialColors$1["light"],
    "table-dark-border-color": colors$1["gray-200"],
    "table-dark-color": specialColors$1["body-bg"],
    "input-disabled-bg": colors$1["gray-400"],
    "custom-file-button-color": colors$1["white"],
    "custom-file-border-color": colors$1["gray-200"],
    "dropdown-bg": colors$1["gray-200"],
    "dropdown-divider-bg": "rgba(0, 0, 0, .15)",
    "dropdown-link-color": specialColors$1["body-color"],
    "dropdown-link-hover-color": specialColors$1["body-color"],
    "dropdown-link-hover-bg": "rgba(255, 255, 255, .075)",
    "nav-link-disabled-color": "rgba(255, 255, 255, .4)",
    "nav-tabs-border-color": colors$1["gray-200"],
    "nav-tabs-link-active-color": specialColors$1["body-color"],
    "nav-tabs-link-active-border-color": colors$1["gray-200"],
    "navbar-dark-color": "rgba(255, 255, 255, .75)",
    "navbar-dark-hover-color": colors$1["white"],
    "pagination-color": colors$1["white"],
    "pagination-bg": colors$1["gray-200"],
    "pagination-border-color": colors$1["transparent"],
    "pagination-hover-color": colors$1["white"],
    "pagination-hover-bg": "rgba(255, 255, 255, .4)",
    "pagination-hover-border-color": colors$1["transparent"],
    "pagination-disabled-color": "rgba(255, 255, 255, .4)",
    "pagination-disabled-bg": colors$1["gray-200"],
    "pagination-disabled-border-color": colors$1["transparent"],
    "card-cap-bg": "rgba(255, 255, 255, .075)",
    "card-bg": colors$1["gray-200"],
    "card-light-color": specialColors$1["body-bg"],
    "popover-bg": colors$1["gray-200"],
    "popover-header-bg": specialColors$1["bg-header"],
    "toast-background-color": colors$1["gray-200"],
    "toast-border-color": "rgba(0, 0, 0, .2)",
    "toast-header-color": specialColors$1["body-color"],
    "toast-header-background-color": colors$1["gray-200"],
    "toast-header-border-color": "rgba(0, 0, 0, .2)",
    "modal-content-bg": colors$1["gray-200"],
    "modal-header-border-color": "rgba(0, 0, 0, .2)",
    "list-group-bg": colors$1["gray-200"],
    "list-group-border-color": colors$1["transparent"],
    "list-group-hover-bg": "rgba(255, 255, 255, .4)",
    "list-group-disabled-color": "rgba(255, 255, 255, .4)",
    "list-group-action-color": colors$1["white"],
    "list-group-action-hover-color": colors$1["white"],
    "list-group-active-color": colors$1["white"],
    "list-group-action-active-color": colors$1["white"],
    "list-group-action-active-bg": colors$1["gray-200"],
    "breadcrumb-divider-color": specialColors$1["body-color"],
    "breadcrumb-active-color": specialColors$1["body-color"],
    "close-color": colors$1["white"],
    "input-border": colors$1["transparent"],
    "input-focus-color": colors$1["gray-800"],
    "card-header-primary": "rgba(255, 255, 255, .075)",
    "card-border-primary": colors$1["transparent"],
    "modal-secondary-btn": "rgba(255, 255, 255, .075)",
    "dropdown-link-disabled": colors$1["gray-500"],
    "card-button-secondary": "#5b6977",
    "tabs-nav-link-bg": specialColors$1["secondary"],
    "tabs-nav-link-color": specialColors$1["body-color"],
    "application-drawer-top-link": specialColors$1["body-color"],
    "focus-outline-color": "#ffffff",
    "focus-outline-color-inputs": "#ffffff",
    "focus-background-color": "#ffffff",
    "focus-color": colors$1["black"],
    "footer-bg": specialColors$1["dark"],
    "footer-link-hover": colors$1["gray-400"],
    "background-button-query": "#4D5C6A",
    "background-button-query-disabled": "#2b3e50",
    "query-text-focus": colors$1["black"],
    "statistics-button": "#F06824",
    "grid-overlay-background-color": "rgba(43, 62, 80, 0.66)",
    "grid-resize-handle-color": "rgba(134, 142, 150, 0.66)",
    "grid-selected-cell-border-color": specialColors$1["body-color"],
    "grid-input-focus-border-color": "rgba(255, 255, 255, 0.4)",
    "grid-selected-row-background-color": "rgba(255, 255, 255, 0.07)",
    "error-overlay-background-color": "rgba(43, 62, 80, 0.9)",
};
const contrastRatio$1 = { "yiq-contrasted-threshold": 185, "filter-base64": 0, "filter-queryIcons": "brightness(0) invert(1)" };
const darkOtherVariables = Object.assign({}, contrastRatio$1);
const darkVariables = Object.assign(Object.assign(Object.assign({}, colors$1), specialColors$1), attributes$1);

const colors = {
    white: "#fff",
    "gray-100": "#f5f5f5",
    "gray-200": "#ecf0f1",
    "gray-300": "#dee2e6",
    "gray-400": "#6D747E",
    "gray-500": "#b4bcc2",
    "gray-600": "#95a5a6",
    "gray-700": "#7b8a8b",
    "gray-800": "#343a40",
    "gray-900": "rgb(88, 88, 88)",
    black: "#000",
    blue: "#0058A9",
    indigo: "#6610f2",
    purple: "#6f42c1",
    pink: "#e83e8c",
    red: "#D90D0E",
    orange: "#f0ad4e",
    yellow: "#F1AA12",
    green: "#01832B",
    teal: "#20c997",
    cyan: "#0E7F91",
    transparent: "hsl(0deg 0% 0% / 0%)",
    lightgreen: "#90ee90",
    lightred: "#ff6347",
};
const specialColors = {
    primary: colors["blue"],
    secondary: colors["gray-400"],
    success: colors["green"],
    info: colors["cyan"],
    warning: colors["yellow"],
    danger: colors["red"],
    light: "#dee0e3",
    dark: colors["gray-400"],
    "body-bg": "#fff",
    "body-color": colors["gray-900"],
    "bg-header": "#FAFAFA",
    "dark-contrast": "#212529",
    "light-primary-bg": "#b8d0e7",
    "light-primary-color": "#001325",
    "light-secondary-bg": "#e2e3e5",
    "light-secondary-color": "#393c42",
    "light-success-bg": "#cce6d5",
    "light-success-color": "#014416",
    "light-info-bg": "#cfe5e9",
    "light-info-color": "#07424b",
    "light-warning-bg": "#fceed0",
    "light-warning-color": "#7d5809",
    "light-danger-bg": "#f7cfcf",
    "light-danger-color": "#6f0707",
    "light-light-bg": "#f5f5f6",
    "light-light-color": "#6a6b6d",
    "light-dark-bg": "#cbced2",
    "light-dark-color": "#fff",
};
const attributes = {
    "input-border-color": "#516d87", //specialColors["primary"],
    "input-group-addon-color": specialColors["body-color"],
    "input-group-addon-bg": colors["gray-400"],
    "text-muted": "rgba(0, 0, 0, .55)", //"rgba(0, 0, 0, .5)",
    "table-accent-bg": "rgba(255, 255, 255, .05)",
    "table-hover-bg": "rgba(0, 0, 0, 0.02)",
    "table-border-color": "rgba(0, 0, 0, .15)",
    "table-head-bg": specialColors["light"],
    "table-dark-bg": specialColors["light"],
    "table-dark-border-color": colors["gray-200"],
    "table-dark-color": specialColors["body-bg"],
    "input-disabled-bg": colors["gray-300"],
    "custom-file-button-color": specialColors["body-color"],
    "custom-file-border-color": colors["gray-600"],
    "dropdown-bg": "#f7f7f8",
    "dropdown-divider-bg": specialColors["body-color"],
    "dropdown-link-color": "#4a4949",
    "dropdown-link-hover-color": specialColors["body-color"],
    "dropdown-link-hover-bg": "rgba(0, 0, 0, .075)",
    "nav-link-disabled-color": colors["gray-400"],
    "nav-tabs-border-color": colors["gray-200"],
    "nav-tabs-link-active-color": specialColors["body-color"],
    "nav-tabs-link-active-border-color": colors["gray-400"],
    "navbar-dark-color": "rgba(203, 213, 236, 1)",
    "navbar-dark-hover-color": colors["white"],
    "pagination-color": specialColors["body-color"],
    "pagination-bg": colors["gray-200"],
    "pagination-border-color": "#707070", // colors["transparent"],
    "pagination-hover-color": colors["white"],
    "pagination-hover-bg": specialColors["primary"],
    "pagination-hover-border-color": "#707070", //colors["transparent"],
    "pagination-disabled-color": "#707070",
    "pagination-disabled-bg": specialColors["bg-header"],
    "pagination-disabled-border-color": colors["transparent"],
    "card-cap-bg": "#F7F7F7",
    "card-bg": colors["white"],
    "card-light-color": specialColors["body-color"],
    "popover-bg": specialColors["bg-header"],
    "popover-header-bg": colors["gray-200"],
    "toast-background-color": colors["gray-200"],
    "toast-border-color": "rgba(0, 0, 0, .2)",
    "toast-header-color": specialColors["body-color"],
    "toast-header-background-color": colors["gray-200"],
    "toast-header-border-color": "rgba(0, 0, 0, .2)",
    "modal-content-bg": specialColors["body-bg"],
    "modal-header-border-color": "rgba(0, 0, 0, .2)",
    "list-group-bg": colors["gray-200"],
    "list-group-border-color": colors["transparent"],
    "list-group-hover-bg": "rgba(255, 255, 255, .4)",
    "list-group-disabled-color": colors["gray-400"],
    "list-group-action-color": specialColors["secondary"],
    "list-group-action-hover-color": colors["white"],
    "list-group-active-color": colors["white"],
    "list-group-action-active-color": colors["white"],
    "list-group-action-active-bg": colors["gray-400"],
    "breadcrumb-divider-color": specialColors["body-color"],
    "breadcrumb-active-color": specialColors["body-color"],
    "close-color": specialColors["secondary"],
    "input-border": colors["gray-600"],
    "input-focus-color": specialColors["primary"],
    "card-header-primary": specialColors["primary"],
    "card-border-primary": specialColors["light-primary-bg"],
    "modal-secondary-btn": specialColors["secondary"],
    "dropdown-link-disabled": "#707070",
    "card-button-secondary": specialColors["light"],
    "tabs-nav-link-bg": specialColors["light"],
    "tabs-nav-link-color": specialColors["body-color"],
    "application-drawer-top-link": specialColors["primary"],
    "focus-outline-color": "#f06721",
    "focus-outline-color-inputs": "#f06721",
    "focus-background-color": "#f06721",
    "focus-color": colors["black"],
    "footer-bg": specialColors["light"],
    "footer-link-hover": colors["gray-800"],
    "background-button-query": "rgba(0, 87, 168, 1)",
    "background-button-query-disabled": "rgba(109, 116, 126)",
    "query-text-focus": colors["white"],
    "statistics-button": colors["white"],
    "grid-overlay-background-color": "rgba(255, 255, 255, 0.66)",
    "grid-resize-handle-color": "rgba(149, 165, 166, 0.5)",
    "grid-selected-cell-border-color": specialColors["primary"],
    "grid-input-focus-border-color": "rgba(0, 87, 168, 0.4)",
    "grid-selected-row-background-color": "rgba(237, 241, 242, 1)",
    "error-overlay-background-color": "rgba(255, 255, 255, 0.9)",
};
const contrastRatio = { "yiq-contrasted-threshold": 110, "filter-base64": 0.7, "filter-queryIcons": "invert(0.5)" };
const lightOtherVariables = Object.assign({}, contrastRatio);
const lightVariables = Object.assign(Object.assign(Object.assign({}, colors), specialColors), attributes);

class ThemeManager {
    get currentTheme() {
        return this._themeSubject.value;
    }
    constructor() {
        this._themeSubject = new BehaviorSubject(undefined);
        this.theme$ = this._themeSubject.asObservable();
    }
    static get instance() {
        if (!ThemeManager._instance) {
            window.ThemeManager = ThemeManager._instance = new ThemeManager();
        }
        return ThemeManager._instance;
    }
    initialize(doConsiderLocalStorage = true) {
        this._doConsiderLocalStorage = doConsiderLocalStorage;
        let previouslySavedTheme;
        if (this._doConsiderLocalStorage) {
            previouslySavedTheme = localStorage.getItem("theme");
        }
        this.setTheme(previouslySavedTheme !== null && previouslySavedTheme !== void 0 ? previouslySavedTheme : "light");
        setAssetPath(this.getAssetPath(document.head.baseURI, __webpack_public_path__));
    }
    getAssetPath(baseUri, webpackPublicPath) {
        let assetPath;
        if (baseUri[baseUri.length - 1] === "/") {
            assetPath = baseUri;
        }
        else {
            assetPath = baseUri + "/";
        }
        if (webpackPublicPath) {
            if (webpackPublicPath[0] === "/") {
                assetPath += webpackPublicPath.substring(1);
            }
            else {
                assetPath += webpackPublicPath;
            }
        }
        if (assetPath[assetPath.length - 1] !== "/") {
            assetPath += "/";
        }
        return assetPath;
    }
    setTheme(theme) {
        if (theme == "light") {
            this.setCssVariables(lightVariables);
            this.setCssNotColorVariables(lightOtherVariables);
        }
        else {
            this.setCssVariables(darkVariables);
            this.setCssNotColorVariables(darkOtherVariables);
        }
        if (this._doConsiderLocalStorage) {
            localStorage.setItem("theme", theme);
        }
        this._themeSubject.next(theme);
    }
    setCustomTheme(primaryVars, secundaryVars) {
        this.setCssVariables(primaryVars);
        this.setCssNotColorVariables(secundaryVars);
    }
    toggleTheme() {
        let currentTheme = this.currentTheme;
        if (currentTheme == "light") {
            currentTheme = "dark";
        }
        else {
            currentTheme = "light";
        }
        this.setTheme(currentTheme);
    }
    rgbToHsl(red, green, blue) {
        const r = Number(trim(red)) / 255;
        const g = Number(trim(green)) / 255;
        const b = Number(trim(blue)) / 255;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let h, s, l = (max + min) / 2;
        if (max === min) {
            h = s = 0; // achromatic
        }
        else {
            const d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        h = Math.round(360 * h);
        s = Math.round(100 * s);
        l = Math.round(100 * l);
        return [h, s, l];
    }
    // from @josh3736 | https://stackoverflow.com/a/3732187
    colorToHsl(color) {
        if (color === undefined) {
            console.error("Undefined color!");
            return [0, 0, 16]; // defaults to dark gray
        }
        if (color.slice(0, 1) === "#") {
            if (color.length === 4) {
                const r = parseInt(color.substr(1, 1) + color.substr(1, 1), 16);
                const g = parseInt(color.substr(2, 1) + color.substr(2, 1), 16);
                const b = parseInt(color.substr(3, 1) + color.substr(3, 1), 16);
                return this.rgbToHsl(r, g, b);
            }
            else {
                const r = parseInt(color.substr(1, 2), 16);
                const g = parseInt(color.substr(3, 2), 16);
                const b = parseInt(color.substr(5, 2), 16);
                return this.rgbToHsl(r, g, b);
            }
        }
        else if (color.slice(0, 4) === "rgba") {
            const [r, g, b] = color.slice(5, -1).split(",");
            return this.rgbToHsl(r, g, b).slice(0, 3);
        }
        else if (color.slice(0, 3) === "rgb") {
            const [r, g, b] = color.slice(4, -1).split(",");
            return this.rgbToHsl(r, g, b);
        }
        else if (color.slice(0, 4) === "hsla") {
            return color.slice(5, -1).split(",").slice(0, 3);
        }
        else if (color.slice(0, 3) === "hsl") {
            return color.slice(4, -1).split(",");
        }
        else {
            // named color values are not yet supported
            console.error("Named color values are not supported in the config. Convert it manually using this chart: https://htmlcolorcodes.com/color-names/");
            return [0, 0, 16]; // defaults to dark gray
        }
    }
    setCssVariables(variables) {
        Object.keys(variables).forEach((variable) => {
            const hsl = this.colorToHsl(variables[variable]);
            const alpha = this.getAlpha(variables[variable]);
            document.documentElement.style.setProperty(`--${variable}`, `hsla(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%, ${alpha})`);
            document.documentElement.style.setProperty(`--${variable}-h`, hsl[0]);
            document.documentElement.style.setProperty(`--${variable}-s`, `${hsl[1]}%`);
            document.documentElement.style.setProperty(`--${variable}-l`, `${hsl[2]}%`);
            document.documentElement.style.setProperty(`--${variable}-a`, `${alpha}`);
        });
    }
    getAlpha(color) {
        if (color === undefined) {
            //console.error("Undefined color!");
            return 1;
        }
        if (color.slice(0, 4) === "rgba") {
            const rgba = color.slice(5, -1).split(",");
            return rgba[3];
        }
        else if (color.slice(0, 4) === "hsla") {
            const hsla = color.slice(5, -1).split(",");
            return hsla[3];
        }
        else {
            return 1;
        }
    }
    setCssNotColorVariables(variables) {
        Object.keys(variables).forEach((variable) => {
            document.documentElement.style.setProperty(`--${variable}`, variables[variable]);
        });
    }
}
ThemeManager._instance = window.ThemeManager;

export { ThemeManager as T };

//# sourceMappingURL=theme-manager-3e7fd8c2.js.map